import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../app.constants';
import { ReleaseNote } from './release-notes.model';
import { JhiLanguageService } from '../shared/core-utils';

@Injectable()
export class ReleaseNotesService {

    private readonly resourceUrl: string;

    constructor(private http: HttpClient,
                private languageService: JhiLanguageService) {
        this.resourceUrl = SERVER_API_URL + 'release-notes';
    }

    getLatest(): Observable<HttpResponse<ReleaseNote>> {
        return this.http.get<ReleaseNote>(this.resourceUrl + '/latest', { observe: 'response' });
    }

    getContent(version: string): Observable<HttpEvent<string>> {
        const options: any = { responseType: 'text' };
        const currentLang = this.languageService.getCurrentLanguage();
        const langExtension = currentLang !== this.languageService.defaultLanguage ? '_' + currentLang : '';
        return this.http.get<string>(`/ibpworkbench/main/app/content/release-notes/${currentLang}/${version}${langExtension}.html`, options);
    }

    dontShowAgain(): Observable<void> {
        return this.http.put<void>(this.resourceUrl + '/toggle?showAgain=' + false, {});
    }

    showReleaseNotes(userId: number): Observable<HttpResponse<boolean>> {
        return this.http.get<boolean>(this.resourceUrl + `/showReleaseNotes?userId=${userId}`, { observe: 'response' });
    }
}
